import React from 'react'

const ShowLightText = ({text}) => {
  // Recursively clone React elements to preserve all props including function props
  const cloneElement = (element) => {
    if (React.isValidElement(element)) {
      // If it has children, recursively clone them too
      const children = React.Children.map(element.props?.children, (child) => {
        if (React.isValidElement(child)) {
          return cloneElement(child);
        }
        return child;
      });
      return React.cloneElement(element, element.props, children);
    }
    return element;
  };

  // If text is a fragment or array, process each child
  const processText = (content) => {
    if (Array.isArray(content)) {
      return content.map((item, index) => 
        React.isValidElement(item) ? cloneElement(item) : item
      );
    }
    if (React.isValidElement(content)) {
      return cloneElement(content);
    }
    return content;
  };

  return (
    <div style={{color:"#6C757D",marginBottom:"6px", fontSize:"14px", pointerEvents: "auto"}}>
      {processText(text)}
    </div>
  )
}

export default ShowLightText